// source from ==> https://github.com/awesomejerry/react-native-qrcode-svg
import QRCode from 'qrcode'

function genMatrix(value, errorCorrectionLevel) {
  const arr = Array.prototype.slice.call(QRCode.create(value, { errorCorrectionLevel }).modules.data, 0)
  const sqrt = Math.sqrt(arr.length)
  return arr.reduce((rows, key, index) => (index % sqrt === 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows, [])
}

export default genMatrix
